<template>
  <div class="h5-container">
    <div class="h5-header">
      <div class="back-button" @click="goBack">
        <el-icon><ArrowLeft /></el-icon>
      </div>
      <h1>获取兑换码</h1>
      <div class="header-right"></div>
    </div>
    <div class="h5-content">
      <comForm
        ref="formRef"
        :formItem="formItem"
        :model="redemptionCodeData"
        :rules="rules"
        position="right"
      >
        <template #spuId>
          <el-select v-model="redemptionCodeData.spuId" placeholder="请选择套餐" @change="changeSpu">
            <el-option
              v-for="(plan, index) in plans"
              :key="index"
              :label="plan.name"
              :value="plan.id"
            />
          </el-select>
        </template>
        <template #categoryId>
          <el-select v-model="redemptionCodeData.categoryId" placeholder="请选择规格" @change="changeCategory">
            <el-option
              v-for="(norm, index) in categoryList"
              :key="index"
              :label="norm.name"
              :value="norm.id"
            />
          </el-select>
        </template>
        <template #skuId>
          <el-select v-model="redemptionCodeData.skuId" placeholder="请选择SKU">
            <el-option v-for="sku in skuList" :key="sku.id" :label="`${sku.nickName} (库存: ${sku.stock || 0})`" :value="sku.id" :disabled="sku.stock <= 0" />
          </el-select>
        </template>
        <template #operator>
          <el-select v-model="redemptionCodeData.operator" placeholder="请选择">
            <el-option-group v-for="group in operatorList" :key="group.deptId" :label="group.deptName">
              <el-option
                v-for="item in group.children"
                :key="item.id"
                :label="item.nickName"
                :value="item.id"
              />
            </el-option-group>
          </el-select>
        </template>
            <template #keyAccountOperator>
          <el-select v-model="redemptionCodeData.keyAccountOperator" clearable filterable placeholder="请选择">
              <el-option
                v-for="item in keyAccountOperatorNameList"
                :key="item.id"
                :label="item.nickName"
                :value="item.id"
              />
          </el-select>
        </template>
        <template #userId>
          <div class="key-account-selects">
            <el-select
              v-model="selectedKeyAccountId"
              filterable
              clearable
              placeholder="请选择大客户"
              class="ka-select"
              @change="onKeyAccountChange"
            >
              <el-option v-for="k in keyAccountOptions" :key="k.id" :label="k.name" :value="k.id" />
            </el-select>
            <el-select
              v-model="redemptionCodeData.userId"
              filterable
              clearable
              placeholder="请选择子账号"
              class="ka-select"
              @change="onSubAccountChange"
            >
              <el-option v-for="u in subAccountOptions" :key="u.id" :label="u.name" :value="u.id" />
            </el-select>
          </div>
        </template>
        <template #payCertificate>
          <div >
              <uploadPayCertificate
              v-model="redemptionCodeData.payCertificate"
              :action="API_CONFIG.uploadAction.url"
              accept="image/*"
              :max-size="10"
              :limit="5"
            ></uploadPayCertificate>
            <div style="font-size: 12px; color: #999;">聚焦窗口支持直接复制粘贴上传截图</div>
          </div>
        </template>
      </comForm>
      <div class="h5-footer">
        <el-button type="primary" @click="submit" :loading="loading" :disabled="loading">确 定</el-button>
      </div>
    </div>
  </div>
  
  <!-- 兑换码弹窗 -->
  <div v-if="exchangeCodeDialogVisible" class="exchange-code-dialog-overlay">
    <div class="exchange-code-dialog">
      <div class="exchange-code-dialog-header">
        <h3>兑换码</h3>
        <button class="close-btn" @click="exchangeCodeDialogVisible = false">
          <span>&times;</span>
        </button>
      </div>
      <div class="exchange-code-dialog-content">
        <div class="code-list">
          <div v-for="(code, index) in exchangeCodes" :key="index" class="code-item">
            <span class="code-text">{{ code }}</span>
            <el-button type="primary" size="small" @click="copyCode(code)">复制</el-button>
          </div>
        </div>
      </div>
      <div class="exchange-code-dialog-footer">
        <el-button @click="exchangeCodeDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="copyAllCodes">一键复制全部({{exchangeCodes.length}})</el-button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { ArrowLeft } from "@element-plus/icons-vue";
import comForm from "@/components/comForm/index.vue";
import API_CONFIG from "@/views/productMgt/redemptionCodeGeneratePage/api.json";
import request from "@/utils/request.ts";
import { ElMessage } from "element-plus";
import { transformToTreeData } from "@/utils/index.ts";
import uploadPayCertificate from "@/views/userMgt/userPage/components/uploadPayCertificate.vue";
import { getDictData } from "@/utils/index.ts";
import { getUserInfo } from "@/utils/auth";
import debounce from 'lodash-es/debounce.js';

const loading = ref(false);
const formRef = ref(null);
const formItem = ref([
  {
    label: "套餐名称",
    prop: "spuId",
    width: 120,
    span: 24,
    type: "custom"
  },
  {
    label: "规格",
    prop: "categoryId",
    width: 120,
    span: 24,
    type: "custom",
    show: data => {
      return data.spuId;
    }
  },
  {
    label: "sku",
    prop: "skuId",
    width: 120,
    span: 24,
    type: "custom",
    show: data => {
      return data.spuId && data.categoryId;
    }
  },
  {
    label: "数量",
    prop: "codeNum",
    width: 120,
    span: 24,
    type: "input"
  },
  {
    label: "有效天数",
    prop: "validity",
    width: 120,
    span: 24,
    type: "input"
  },
  {
    label: "发放人",
    prop: "operator",
    width: 120,
    span: 24,
    type: "custom"
  },
   {
    label: "大客户经理",
    prop: "keyAccountOperator",
    width: 120,
    span: 24,
    type: "custom",
  },
  {
    label: "大客户",
    prop: "userId",
    width: 120,
    span: 24,
    type: "custom",
  },
  {
    label: "订单类型",
    prop: "orderType",
    width: 120,
    span: 24,
    type: "select",
    optionsPro: async () =>
      getDictData("ORDER_TYPE").filter(ele => ele.value == "6" || ele.value == "7")
  },
    {
    label: "实际支付金额",
    prop: "totalPrice",
    width: 120,
    span: 24,
    type: "input",
  },
  {
    label: "支付或发放凭证",
    prop: "payCertificate",
    width: 120,
    span: 24,
    tips:"优先上传支付凭证，无则请提供发放截图凭证（例：客户需要优先发放设备的凭证）",
    type: "custom"
  },
  {
    label: "备注类型",
    prop: "remarkType",
    width: 120,
    span: 24,
    type: "select",
    optionsPro: async () => {
      return getDictData('DISTRIBUTE_DEVICE_REMARK');
    }
  },
  { label: "发放说明", prop: "remark", width: 120, span: 24, type: "input",placeholder:'请填写券码的用途' }
]);

const rules = {
  spuId: [{ required: true, message: "请选择套餐", trigger: "change" }],
  categoryId: [{ required: true, message: "请选择规格", trigger: "blur" }],
  skuId: [{ required: true, message: "请选择sku", trigger: "blur" }],
  codeNum: [{ required: true, message: "请输入数量", trigger: "blur" }],
  validity: [{ required: true, message: "请输入有效天数", trigger: "blur" }],
  operator: [{ required: true, message: "请选择发放人", trigger: "blur" }],
  userId: [{ required: true, message: "请选择大客户/子账号", trigger: "change" }],
  orderType: [{ required: true, message: "请选择订单类型", trigger: "change" }],
  totalPrice: [{ required: true, message: "请输入实际支付金额", trigger: "blur" },
      {validator: (rule, value, callback) => {
        if (isNaN(value)) {
          callback(new Error('请输入数字'));
        } else if (value < 0) {
          callback(new Error('金额不能小于0'));
        } else {
          callback();
        }
      }, trigger: 'blur'}
    ],
  payCertificate: [{ required: true, message: "请上传支付或发放凭证", trigger: "change" }],
  remarkType:[{ required: true, message: "请选择备注类型", trigger: "change" }],
  remark:[{ required: true, message: "请输入发放说明", trigger: "blur" }],
};

const selectedSku = ref(null);
const redemptionCodeData = ref({
  validity: 90
});
const title = ref("新增券码");
const plans = ref([]);
const categoryList = ref([]);
const skuList = ref([]);
const operatorList = ref([]);
const keyAccountOperatorNameList = ref([]);
// 大客户/子账号：两个可搜索下拉，选中大客户后加载其子账号，选中子账号即 userId
const selectedKeyAccountId = ref("");
const keyAccountOptions = ref([]);
const subAccountOptions = ref([]);
// 查询大客户列表（默认全部，选了大客户经理则按经理过滤）
const loadKeyAccounts = () => {
  const params = {};
  if (redemptionCodeData.value.keyAccountOperator) {
    params.keyAccountManagerId = redemptionCodeData.value.keyAccountOperator;
  }
  request
    .get(API_CONFIG.getKeyAccountList.url, { params })
    .then(res => {
      const list = res.code == 200 ? (res.data || []) : [];
      keyAccountOptions.value = list.map(k => ({ id: k.id, name: k.name }));
    })
    .catch(() => {
      keyAccountOptions.value = [];
    });
};
// 大客户变化：清空已选子账号并加载该大客户的子账号
const onKeyAccountChange = keyAccountId => {
  redemptionCodeData.value.userId = "";
  subAccountOptions.value = [];
  if (!keyAccountId) return;
  request
    .post(API_CONFIG.queryKeyAccountSubAccount.url, {
      pageDomain: { pageNum: 1, pageSize: 9999 },
      keyAccountId
    })
    .then(res => {
      const list = res.code == 200 ? (res.data?.data || []) : [];
      subAccountOptions.value = list.map(u => ({
        id: u.id,
        name: `${u.mobile}(${u.userNo})`
      }));
    })
    .catch(() => {
      subAccountOptions.value = [];
    });
};
const onSubAccountChange = () => {
  formRef.value?.clearValidate(["userId"]);
};
// 大客户经理变化后，重新查询大客户列表并清空已选大客户/子账号
watch(
  () => redemptionCodeData.value.keyAccountOperator,
  () => {
    selectedKeyAccountId.value = "";
    subAccountOptions.value = [];
    redemptionCodeData.value.userId = "";
    loadKeyAccounts();
  }
);
const router = useRouter();
const exchangeCodeDialogVisible = ref(false);
const exchangeCodes = ref([]);

onMounted(() => {
  getSpuList();
  getAllOperator();
  getKeyAccountOperator();
  loadKeyAccounts();
});

// 获取商品套餐列表
const getSpuList = () => {
  request.post(API_CONFIG.querySpu.url).then(res => {
    if (res.code == 200) {
      plans.value = (res.data||[]).filter(ele=>ele.status == '0'&&!ele.hideType.includes('exchangeCode'));
      if (plans.value.length > 0) {
        redemptionCodeData.value.spuId = plans.value[0].id;
        changeSpu(plans.value[0].id);
      }
    } else {
      plans.value = [];
    }
  });
};

// change商品
const changeSpu = spuData => {
  redemptionCodeData.value.categoryId = "";
  selectSku("");
  categoryList.value =
    ((plans.value || []).find(ele => ele.id == spuData)?.goodsCategoryList || []).filter(ele=>ele.status == '0');
  if (categoryList.value.length > 0) {
    redemptionCodeData.value.categoryId = categoryList.value[0].id;
    getSkuList();
  }
};

// change规格
const changeCategory = categoryData => {
  selectSku("");
  getSkuList();
};

// 获取SKU列表
const getSkuList = async () => {
  if (!redemptionCodeData.value.spuId || !redemptionCodeData.value.categoryId) {
    return;
  }
  
  try {
    const params = {
      spuId: redemptionCodeData.value.spuId,
      categoryId: redemptionCodeData.value.categoryId
    };
    const res = await request.post(API_CONFIG.queryCategoryParams.url, params);
    if (res.code === 200) {
      skuList.value = (res.data.goodsSkuList || [])
    }
  } catch (error) {
    console.error("获取SKU列表失败:", error);
    ElMessage.error("获取SKU列表失败");
  }
};

const selectSku = sku => {
  if (sku && sku.id) {
    selectedSku.value = sku.id;
    redemptionCodeData.value.skuId = sku.id;
  } else {
    selectedSku.value = "";
    redemptionCodeData.value.skuId = "";
  }
};

const submit = debounce(async () => {
  const valid = await formRef.value.validData();
  if (!valid) return;
  const params = JSON.parse(JSON.stringify(redemptionCodeData.value));
  loading.value = true;

  request
    .post(API_CONFIG.addUrl.url, params)
    .then(res => {
      if (res.code == 200) {
        ElMessage.success(`${title.value}成功`);
        getNewExchangeCode(params.remark);
        // 重置表单
        redemptionCodeData.value = { validity: 90 };
        selectedKeyAccountId.value = "";
        subAccountOptions.value = [];
        loadKeyAccounts();
        if (plans.value.length > 0) {
          redemptionCodeData.value.spuId = plans.value[0].id;
          changeSpu(plans.value[0].id);
        }
        setTimeout(() => {
          formRef.value && formRef.value.clearValidate();
        });
      } else {
        ElMessage.error(res.msg || `${title.value}失败`);
      }
    })
    .finally(() => {
      loading.value = false;
    });
}, 500);

// 生成兑换码
const getNewExchangeCode = (remarkValue)=>{
  request.post(API_CONFIG.queryUrl.url, {
    pageDomain: { pageNum: 1, pageSize: 9999 },
    remark: remarkValue
  }).then(res => {
    if (res.code == 200) {
      // 过滤创建时间在一分钟以内
      exchangeCodes.value = (res.data.data||[]).filter(ele=>Date.now() - new Date(ele.sysCreateTime) <  60 * 1000).map(ele=>ele.code);
      exchangeCodeDialogVisible.value = true;
    } else {
      ElMessage.error(res.msg || `生成兑换码失败`);
    }
  });
}


const getAllOperator = () => {
  request
    .post(API_CONFIG.getOperators.url, {
      pageDomain: { pageNum: 1, pageSize: 9999 }
    })
    .then(res => {
      if (res.code == 200) {
        operatorList.value = transformToTreeData(res.data.data)
        // 发放人默认选中当前登录系统账号，匹配不到则留空
        const currentUserId = getUserInfo()?.id;
        const flat = (operatorList.value || []).flatMap(g => g.children || []);
        if (currentUserId && flat.some(item => item.id == currentUserId)) {
          redemptionCodeData.value.operator = currentUserId;
        }
      } else {
        operatorList.value = [];
      }
    });
};

// 获取大客户经理
const getKeyAccountOperator = () => {
  request
    .get(API_CONFIG.getKeyAccountOperator.url)
    .then((res) => {
      if (res.code == 200) {
        keyAccountOperatorNameList.value = res.data || [];
      } else {
        keyAccountOperatorNameList.value = [];
      }
    });
};

// 返回上一页
const goBack = () => {
  router.push('/h5/workPlace');
};

// 复制兑换码
const copyCode = (code) => {
  navigator.clipboard.writeText(code).then(() => {
    ElMessage.success('兑换码复制成功');
  }).catch(() => {
    ElMessage.error('兑换码复制失败');
  });
};

// 一键复制所有兑换码
const copyAllCodes = () => {
  const allCodes = exchangeCodes.value.join('\n');
  navigator.clipboard.writeText(allCodes).then(() => {
    ElMessage.success('所有兑换码复制成功');
  }).catch(() => {
    ElMessage.error('兑换码复制失败');
  });
};
</script>  
<style lang="scss" scoped>
.key-account-selects {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.ka-select {
  width: 100%;
}

.h5-container {
  min-height: 100vh;
  background-color: #f5f7fa;
  padding-bottom: 20px;
}

.h5-header {
  background-color: #409eff;
  color: white;
  padding: 16px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  h1 {
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    flex: 1;
  }
  .back-button {
    font-size: 20px;
    cursor: pointer;
    padding: 0 10px;
  }
  .header-right {
    width: 40px;
  }
}

.h5-content {
  padding: 16px;
  max-width: 600px;
  margin: 0 auto;
}

.h5-footer {
  margin-top: 20px;
  text-align: center;
  padding: 0 16px;
  position: sticky;
  bottom: 0;
  background-color: #f5f7fa;
  padding-bottom: 20px;
  el-button {
    width: 100%;
    height: 48px;
    font-size: 16px;
  }
}

.sku-grid {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}

.sku-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.sku-option {
  flex: 1;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  min-width: 20%;
  max-width: 24%;
}

.sku-option:hover,
.sku-selected {
  border-color: #409eff;
  box-shadow: 0 0 8px rgba(64, 158, 255, 0.3);
}

.sku-title {
  position: absolute;
  font-size: 10px;
  color: #fff;
  padding: 0 8px;
  background: #f56c6c;
  top: -10px;
  left: -1px;
  height: 20px;
  line-height: 20px;
  border-radius: 8px 0;
}

.sku-duration {
  font-size: 16px;
}

.sku-price {
  font-size: 18px;
  color: #f56c6c;
  margin-bottom: 10px;
}

.sku-original-price {
  color: #fff;
  background: skyblue;
  height: 16px;
  line-height: 16px;
  position: absolute;
  bottom: 0;
  left: 0px;
  font-size: 12px;
  width: 100%;
}
/* 兑换码弹窗样式 */
.exchange-code-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.exchange-code-dialog {
  width: 90%;
  max-width: 400px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.exchange-code-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.exchange-code-dialog-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exchange-code-dialog-content {
  padding: 16px;
  max-height: 300px;
  overflow-y: auto;
}

.code-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.code-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background-color: #f5f7fa;
  border-radius: 8px;
}

.code-text {
  font-family: 'Courier New', monospace;
  font-size: 14px;
  word-break: break-all;
}

.exchange-code-dialog-footer {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border-top: 1px solid #f0f0f0;
  gap: 12px;
}

.exchange-code-dialog-footer button {
  flex: 1;
}
</style>